// extracted by mini-css-extract-plugin
export default {"containerCard":"CardComplete_containerCard__PJSF8","arrowL":"CardComplete_arrowL__Y5Obt","arrowR":"CardComplete_arrowR__lnGRP"};